<template>
  <auth-layout>
    <card title="Confirm Account">
      <form @submit.prevent>
        <div class="row">
          <div class="col-md-12">
            <fg-input type="password"
              placeholder="Password"
              :class="{ 'form-group--error': $v.password.$error }"
              v-model="$v.password.$model">
            </fg-input>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <fg-input type="password"
              placeholder="Confirm Password"
              :class="{ 'form-group--error': $v.confirmPassword.$error }"
              @keyupEnter="confirmAccount"
              v-model="$v.confirmPassword.$model">
            </fg-input>
          </div>
        </div>
        
        <div class="text-center">
          <p-button type="info" block
            :loading="isLoading"
            @click.native.prevent="confirmAccount">
            <span v-if="isLoading">Confirming...</span>
            <span v-else>Confirm</span>
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
      <template v-slot:footer>
        <router-link to="/login">Login</router-link>
      </template>
    </card>
  </auth-layout>
</template>

<script>
import AuthLayout from '../../layout/AuthLayout.vue';
import Card from '../../components/Cards/Card.vue';
import ziperase from '../../services/ziperase';
import { notify } from '../../services/notify';
import { required, sameAs } from 'vuelidate/lib/validators';

export default {
  components: {
    AuthLayout,
    Card
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      isLoading: false
    }
  },
  validations: {
    password: { required },
    confirmPassword: { sameAsPassword: sameAs('password') }
  },
  methods: {
    async confirmAccount() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        notify().error('Please make sure your password is the same.')
        return;
      }

      try {
        this.isLoading = true;
        await ziperase.confirmAccount(this.password, this.$route.query.token);
        notify().success('Success! Your account has been confirmed.');
      } catch (error) {
        notify().error('Failed to confirm your account.');
      }

      this.isLoading = false;
    }
  }
};
</script>
